import {
    DAILY_DEVICE_AUDIT_REQUEST,
    DAILY_DEVICE_AUDIT_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

const INIT_STATE = {
    loading: false,
    result: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case DAILY_DEVICE_AUDIT_REQUEST:
            return { ...state, loading: true }

        case DAILY_DEVICE_AUDIT_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "DAILY_DEVICE_AUDIT"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};